import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { EntiDelegatiDatasource } from 'src/app/services/enti-delegati.datasource';
import { EventiService } from 'src/app/services/eventi.service';
import { environment } from 'src/environments/environment';
import { MatPaginator } from '@angular/material/paginator';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-enti-delegati',
  templateUrl: './enti-delegati.component.html',
  styleUrls: ['./enti-delegati.component.css']
})
export class EntiDelegatiComponent implements OnInit, AfterViewInit {
  idEventoParam?: number;
  arrowFlag: boolean = false;
  dataSource: EntiDelegatiDatasource;
  //questa variabile, associata a *matHeaderRowDef, definisce l'ordine di visualizzazione delle colonne
  //displayedColumns: string[] = ['idEnte', 'description', 'idEvento', 'idEventoPcEnte', 'idTpEnte', 'nodeCode', 'organId'];
  displayedColumns: string[] = ['idEnte', 'description', 'EntiDelegati'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('orderBy') orderBy: MatSelect;
  allModStatoComp: string = "";
  risultatiPerPagina: number = 5;
  public form: FormGroup = new FormGroup({
    idEnte: new FormControl(null),
    description: new FormControl(null),
    nuovoEnteDelegato: new FormControl(false),
    //idEvento: new FormControl(null, null),
    //idEventoPcEnte: new FormControl(null, null),
    //idTpEnte: new FormControl(null, null),
    //nodecode: new FormControl(null, null),
    //organId: new FormControl(null, null)
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private eventiService: EventiService,
    private alertsCenterService: AlertsCenterService
  ) { }

  ngOnInit(): void {
    this.idEventoParam = this.route.snapshot.params.id;
    this.dataSource = new EntiDelegatiDatasource(this.eventiService);
    this.dataSource.errors$.subscribe(res => {
      if (res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })

    // Se cambio "nuovoEnteDelegato", abilito/disabilito idEnte
    this.form.get('nuovoEnteDelegato')!.valueChanges.subscribe((value: boolean) => {
    const idEnteControl = this.form.get('idEnte');
    if (value) {
      idEnteControl?.disable({ emitEvent: false });
    } else {
      idEnteControl?.enable({ emitEvent: false });
    }
  });

  // Se cambio "idEnte", abilito/disabilito nuovoEnteDelegato
  this.form.get('idEnte')!.valueChanges.subscribe((value: any) => {
    const nuovoEnteDelegatoControl = this.form.get('nuovoEnteDelegato');
    if (value !== null && value !== '' && value !== 'null') {
      nuovoEnteDelegatoControl?.disable({ emitEvent: false });
    } else {
      nuovoEnteDelegatoControl?.enable({ emitEvent: false });
    }
  });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.sort.direction = "asc";
      this.sort.active = "idEnte";
      let baseFilter = this.getBaseFilter();
      baseFilter.page = 0;
      this.ricercaEntiDelegati(baseFilter);
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => {
            this.ricercaEntiDelegati(this.getBaseFilter());
          }))
        .subscribe();

      this.dataSource.counter$
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();
    });
  }

  onNavigate(path: string) {
    switch (path) {
      case 'modifica-evento': {
        this.router.navigate([path + '/' + this.idEventoParam]);
        break;
      }
      default: {
        break;
      }
    }
  }

  onReset() {
    this.form.reset();
    this.ricercaEntiDelegati(this.getBaseFilter());
  }

  filterResult() {
    let baseFilter = this.getBaseFilter();
    baseFilter.idEnte = String(this.form.controls.idEnte.value);
    baseFilter.description = String(this.form.controls.description.value);
    if(this.form.controls.nuovoEnteDelegato.value){
      baseFilter.idEnte = "-1";
    }
    this.ricercaEntiDelegati(baseFilter);
  }

  /*public setAllEntiDelegati(completed: boolean) {
    if (completed === true) {
      this.allModStatoComp = "S";
    } else {
      this.allModStatoComp = "N"
    }
  }*/

  public changeStateEntiDelegati(element: any) {
    element.isCheck = !(element.idEventoPcEnte && element.idEvento);
    console.log(element);
    if (element.isCheck) {
      this.eventiService.postAddEnteDelegato(this.idEventoParam as number, element.idEnte, element.nodeCode, element.organId, element.description).subscribe({
        next: () => {
          this.ricercaEntiDelegati(this.getBaseFilter());
        },
        error: (err) => {
          this.alertsCenterService.showAlert({
            message: `Errore lettura dati`,
            type: 'danger',
            autoClosable: false
          });
        },
      })
    } else {
      this.eventiService.deletedEnteDelegato(element.idEnte, this.idEventoParam).subscribe({
        next: () => {
          this.ricercaEntiDelegati(this.getBaseFilter());
        },
        error: (err) => {
          this.alertsCenterService.showAlert({
            message: `Errore lettura dati`,
            type: 'danger',
            autoClosable: false
          });
        },
      })
    }

  }

  private ricercaEntiDelegati(filter: {
    idEvento: number,
    page: number,
    size: number,
    sort: string,
    idEnte: string,
    description: string,
  }): void {
    this.dataSource.getEntiDelegatiList(filter);
  }

  private getBaseFilter(){
    return {
      idEvento: this.idEventoParam,
      page: this.paginator.pageIndex,
      size: this.paginator.pageSize,
      sort: this.sort.active + ',' + this.sort.direction,
      idEnte: "",
      description: "" 
    }
  }
}